<div class="flex flex-col space-y-5 h-full relative">
  <div class="flex flex-col space-y-3">
    <div
      class="flex flex-col gap-5 lg:flex-row lg:justify-between items-center"
    >
      <div class="flex flex-col">
        <h2 class="text-xl font-semibold">Agregar productos</h2>
        <small>
          Selecciona los productos que deseas agregar con un máximo de
          {{ data.limitSelected }} productos.
        </small>
      </div>
      <div class="flex gap-5 w-full lg:w-1/3">
        <mat-form-field
          class="w-full fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded"
        >
          <input
            [formControl]="searchForm"
            matInput
            type="text"
            placeholder="Buscar artículos por nombre y código..."
          />
        </mat-form-field>
        <button
          class="absolute top-0 right-0 lg:relative"
          mat-dialog-close
          mat-icon-button
          color="warn"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <form
      class="w-full grid grid-cols-2 md:grid-cols-4 gap-5 place-items-end"
      [formGroup]="filterForm"
      (ngSubmit)="submit()"
    >
      <mat-form-field
        class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full"
      >
        <mat-label> Seleccionar categoría </mat-label>
        <input
          formControlName="category"
          type="text"
          placeholder="Escribe el nombre de una categoría"
          aria-label="Nombre de categoría"
          matInput
          [matAutocomplete]="autoCategories"
        />
        <mat-autocomplete
          #autoCategories="matAutocomplete"
          [displayWith]="displayWithCategory"
        >
          <mat-option [value]="0"> Todas las categorías </mat-option>
          <mat-option *ngFor="let category of categories" [value]="category.id">
            {{ category.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field
        class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full"
      >
        <mat-label> Seleccionar subcategoría </mat-label>
        <input
          formControlName="subCategory"
          type="text"
          placeholder="Escribe el nombre de una subcategoría"
          aria-label="Nombre de subcategoría"
          matInput
          [matAutocomplete]="autoSubcategories"
        />
        <mat-autocomplete
          #autoSubcategories="matAutocomplete"
          [displayWith]="displayWithSubCategory"
        >
          <mat-option [value]="0"> Todas las subcategorías </mat-option>
          <mat-option
            *ngFor="let subcategory of subCategoriesFiltered"
            [value]="subcategory.id"
          >
            {{ subcategory.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <button
        type="button"
        class="w-full flex"
        mat-stroked-button
        color="warn"
        [disabled]="productsSelected.length === 0"
        (click)="unMarkAll()"
      >
        <mat-icon>delete</mat-icon>
        <span class="ml-2"> Cancelar seleccionados </span>
      </button>
      <button
        type="submit"
        class="w-full flex"
        mat-flat-button
        color="primary"
        [disabled]="productsSelected.length === 0"
      >
        <mat-icon>add</mat-icon>
        <span class="ml-2">
          Agregar ({{ productsSelected.length | number }}) productos
        </span>
      </button>
    </form>
  </div>
  <mat-divider></mat-divider>
  <div class="w-full overflow-y-auto overflow-x-auto h-full">
    <table class="w-full">
      <thead class="sticky -top-1 z-99">
        <tr class="text-center">
          <th>
            <mat-checkbox
              [disabled]="productsSelected.length === data.limitSelected"
              color="primary"
              (change)="bulkAddProducts($event)"
              [checked]="
                paginatedProductsSelected.length === productsPaginated.length
              "
              [indeterminate]="
                paginatedProductsSelected.length > 0 &&
                paginatedProductsSelected.length < productsPaginated.length
              "
            ></mat-checkbox>
          </th>
          <th>Código</th>
          <th>Nombre</th>
          <th>Categoría</th>
          <th>Subcategoría</th>
          @if (canViewInventory) {
            <th>Stock</th>
          }
        </tr>
      </thead>
      <tbody>
        <tr class="text-center" *ngFor="let product of productsPaginated">
          <td>
            <mat-checkbox
              [disabled]="
                productsSelected.length === data.limitSelected && !product.checked
              "
              color="primary"
              [checked]="product.checked"
              (change)="addProduct($event, product)"
            ></mat-checkbox>
          </td>
          <td>
            {{ product.code }}
          </td>
          <td>
            {{ product.name }}
          </td>
          <td>
            {{ product.subCategory?.category?.name }}
          </td>
          <td>
            {{ product.subCategory?.name }}
          </td>
          @if (canViewInventory) {
          <td>
            {{ product.currentStock | number }}
          </td>
          }
        </tr>
        <tr
          *ngIf="
            !isProductsLoaded || isProductsLoadedError || isProductsNotFound
          "
        >
          <td colspan="6">
            <div
              class="flex items-center justify-center flex-col space-y-4 py-16"
              *ngIf="
                isProductsNotFound && isProductsLoaded && !isProductsLoadedError
              "
            >
              <div
                class="w-20 h-20 p-4 items-center justify-center flex rounded-full bg-slate-100"
              >
                <mat-icon
                  [inline]="true"
                  svgIcon="mat_solid:search_off"
                ></mat-icon>
              </div>
              <span class="text-lg font-semibold max-w-1/2 text-center">
                No se encontraron productos con los criterios de búsqueda
                seleccionados.
              </span>
            </div>
            <div
              class="flex items-center justify-center flex-col space-y-4 py-16"
              *ngIf="
                !isProductsLoaded &&
                !isProductsNotFound &&
                !isProductsLoadedError
              "
            >
              <div
                class="w-20 h-20 p-4 items-center justify-center flex rounded-full bg-slate-100"
              >
                <mat-icon
                  [inline]="true"
                  svgIcon="mat_solid:search_off"
                ></mat-icon>
              </div>
              <span class="text-lg font-semibold max-w-1/2 text-center">
                Espera un momento, estamos buscando los productos...
              </span>
            </div>
            <div
              class="flex items-center justify-center flex-col space-y-4 py-16"
              *ngIf="
                isProductsLoadedError && isProductsLoaded && !isProductsNotFound
              "
            >
              <div
                class="w-20 h-20 p-4 items-center justify-center flex rounded-full bg-slate-100"
              >
                <mat-icon [inline]="true" svgIcon="mat_solid:close"></mat-icon>
              </div>
              <span class="text-lg font-semibold max-w-1/2 text-center">
                Se ha producido un error al cargar los productos.
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <mat-paginator
    class="bg-[#f8fafc] rounded-xl"
    [pageSize]="pagination.size"
    [length]="pagination.length"
    [pageIndex]="pagination.page"
    [pageSizeOptions]="[5, 10, 20, 50]"
  ></mat-paginator>
</div>
